"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeleteFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var DeleteFooter = exports.DeleteFooter = function DeleteFooter(_ref) {
  var isDeletingAsset = _ref.isDeletingAsset,
    _ref$isPreprocessingD = _ref.isPreprocessingDelete,
    isPreprocessingDelete = _ref$isPreprocessingD === void 0 ? false : _ref$isPreprocessingD,
    onClose = _ref.onClose,
    _ref$isPortalReArchit = _ref.isPortalReArchitectureEnabled,
    isPortalReArchitectureEnabled = _ref$isPortalReArchit === void 0 ? false : _ref$isPortalReArchit,
    isLastVersion = _ref.isLastVersion,
    canDelete = _ref.canDelete,
    handleDelete = _ref.handleDelete;
  var target = isLastVersion ? 'asset' : 'version';
  var deleteLabel = isDeletingAsset ? "Deleting ".concat(target, " ...") : "Delete ".concat(target);
  var showCancelButton = isPreprocessingDelete || canDelete;
  var showCloseButton = !canDelete;
  var showDeleteButton = !(isPreprocessingDelete || !canDelete);
  return /*#__PURE__*/_react.default.createElement("div", null, showCancelButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "cancel-button",
    kind: "tertiary",
    onClick: onClose,
    noFill: true
  }, "Cancel") : null, showDeleteButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: isLastVersion ? 'delete-asset-button' : 'delete-version-button',
    kind: "danger",
    onClick: handleDelete,
    isLoading: isDeletingAsset,
    noFill: true
  }, deleteLabel) : null, showCloseButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "close-button",
    kind: "tertiary",
    onClick: onClose,
    noFill: true
  }, isPortalReArchitectureEnabled ? 'Back' : 'Close') : null);
};
var _default = exports.default = DeleteFooter;
//# sourceMappingURL=DeleteFooter.js.map